import Swiper from 'swiper/bundle';

export function product() {
	
	let sliderEl = document.querySelector('.product__gallery.swiper');
	let thumbsEl = document.querySelector('.product__thumbs');
	
	if (sliderEl && thumbsEl) {
		const prevEl = document.querySelector('.product .gallery-navigation__btn--prev');
		const nextEl = document.querySelector('.product .gallery-navigation__btn--next');
		
		let thumbs = new Swiper(thumbsEl, {
			speed: 500,
			slidesPerView: 'auto',
			spaceBetween: 10,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			a11y: true,
		});

		thumbsEl.addEventListener('keydown', (event) => {
			if (event.key !== 'Enter' && event.key !== ' ') return;

			const slide = event.target.closest('.swiper-slide');

			if (!slide) return;

			event.preventDefault();

			const index = thumbs.slides.indexOf(slide);

			if (index !== -1) {
				slider.slideToLoop(index);
			}
		});


		let slider = new Swiper(sliderEl, {
			loop: true,
			speed: 500,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			navigation: {
				prevEl: prevEl,
				nextEl: nextEl
			},
			thumbs: {
				swiper: thumbs,
			},
			a11y: true,
		});
	}
	initDropdown();
}

export function initDropdown() {
  const dropdowns = document.querySelectorAll('[data-dropdown]');
  if (!dropdowns.length) return;

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('[data-dropdown-trigger]');
    const content = dropdown.querySelector('[data-dropdown-content]');

    if (!trigger || !content) return;

    const setContentHidden = (hidden) => {
      content.setAttribute('aria-hidden', String(hidden));
      content.toggleAttribute('inert', hidden);
    };

    setContentHidden(trigger.getAttribute('aria-expanded') !== 'true');

    const open = () => {
      dropdown.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      setContentHidden(false);
      content.style.height = '0px';

      requestAnimationFrame(() => {
        content.style.height = `${content.scrollHeight}px`;
      });
    };

    const close = () => {
      if (content.contains(document.activeElement)) {
        trigger.focus();
      }

      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      content.style.height = `${content.scrollHeight}px`;

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      content.addEventListener(
        'transitionend',
        () => {
          if (!dropdown.classList.contains('is-open')) {
            setContentHidden(true);
            content.style.height = '';
          }
        },
        { once: true }
      );
    };

    const toggle = (e) => {
      e.stopPropagation();

      const isOpen = dropdown.classList.contains('is-open');
      isOpen ? close() : open();
    };

    trigger.addEventListener('click', toggle);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) close();
    });
  });
}
